// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackButton_backBtn__YViBO"};